import { render } from "./Buyer001.vue?vue&type=template&id=1554c851&scoped=true"
import script from "./Buyer001.vue?vue&type=script&lang=js"
export * from "./Buyer001.vue?vue&type=script&lang=js"

import "@/assets/vendors/themefy_icon/themify-icons.css?vue&type=style&index=0&id=1554c851&scoped=true&lang=css"
import "@/assets/vendors/niceselect/css/nice-select.css?vue&type=style&index=1&id=1554c851&scoped=true&lang=css"
import "@/assets/css/style.css?vue&type=style&index=2&id=1554c851&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1554c851"]])

export default __exports__